


















import Vue from 'vue';

export default Vue.extend({
    name: 'Pagination',

    props: {
        selectedPage: Number,
        numberOfPages: Number
    },

    computed: {
        pages: {
            get(): number[] {
                return [...Array(this.numberOfPages).keys()]
                    .map((page) => page + 1)
                    .filter((page) =>
                        page === 1 ||
                        page === this.numberOfPages ||
                        Math.abs(page - this.selectedPage) < 3);
            }
        }
    },

    methods: {
        selectPage(page: number): void {
            this.$emit('selectedPage', page);
        }
    }
});
